import {isNil} from "lodash"

export function assertIsDefined<T>(val: T): asserts val is NonNullable<T> {
	if (isNil(val)) {
		throw new Error(`Expected 'val' to be defined, but received ${val}`)
	}
}
